import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

function AuditorPrivateRoute({ allowedRoles, allowedTypes }) {
  const auditorData = JSON.parse(localStorage.getItem("auditor"));
  
  const auditorRole = auditorData?.role;
  const auditorType = auditorData?.accountType;
  
  // Check if role and type are permitted
  if (!auditorData || !allowedRoles.includes(auditorRole) || !allowedTypes.includes(auditorType)) {
    return <Navigate to="/HomePage" />;
  }

  return <Outlet />;
}

export default AuditorPrivateRoute;